import { SubscribedSessionCard } from "@/features/coaching/components";
import type { SubscribedSession } from "@/features/coaching/models";
import { AppointmentCard } from "@/features/consultations/components";
import type { Appointment } from "@/features/consultations/models";
import { isAppointment } from "@/features/consultations/utils";
import { isSubscribedSession } from "@/features/onboarding/utils";
import { Carousel } from "@/shared/ui";

interface MyAgendaContentProps {
  events: (Appointment | SubscribedSession)[];
}

const getEventCard = (event: MyAgendaContentProps["events"][number]) => {
  if (isAppointment(event)) {
    return <AppointmentCard appointment={event} />;
  }

  if (isSubscribedSession(event)) {
    return <SubscribedSessionCard session={event} />;
  }
};

export const UpcomingEvents = ({ events }: MyAgendaContentProps) => {
  return (
    <Carousel.Root className="contain-inline-size">
      <Carousel.Content className="flex">
        {events.map((event) => {
          const card = getEventCard(event);

          return (
            <Carousel.Item
              key={event.id}
              className="md:basis-7/12 2xl:basis-3/12"
            >
              {card}
            </Carousel.Item>
          );
        })}
      </Carousel.Content>

      <Carousel.PreviousButton />
      <Carousel.NextButton />
    </Carousel.Root>
  );
};
